import axios from 'axios';
import { API_CONFIG } from '../../config/environment';

const http = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userAuthToken');

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let reauthPromise = null;

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('userAuthToken');
      if (!reauthPromise) {
        reauthPromise = import('../anonymousAuth').then(async ({ ensureAnonymousAuth, registerPushToken }) => {
          await ensureAnonymousAuth();
          await registerPushToken();
        }).finally(() => { reauthPromise = null; });
      }
      await reauthPromise;
    }
    return Promise.reject(error);
  },
);
export default http;
